import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useDeepEffect } from "../../abstracts";
import SearchBar from "../../containers/Mapper/LoadDefHomeContainer/SearchBar";

const FeeApplicableToPlanInfoCard = (props) => {
  const {
    planListFilter,
    plans,
    setPlanListFilter,
    setAddedPlans,
    addedPlans,
    setAddedPlansFilter,
    setPlans,
    addedPlansFilter,
    searchAddedPlans,
    searchPlanList,
    setSearchPlanList,
    filteredPlans,
    setFilteredPlans,
    isExclude,
  } = props;
  const [noMatchesFound, setNoMatchesFound] = useState(false);
  useDeepEffect(
    () => {
      let plans = filteredPlans.filter(
        (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
      );
      setPlanListFilter(
        plans.filter((team) => {
          return (
            team.planName
              .toLowerCase()
              .includes(searchPlanList.toLowerCase()) ||
            team.rkPlanNumber.includes(searchPlanList)
          );
        })
      );
    },
    [searchPlanList],
    [filteredPlans]
  );

  useDeepEffect(() => {
    if (!isEmpty(searchPlanList) && isEmpty(planListFilter)) {
      setNoMatchesFound(true);
    } else {
      setNoMatchesFound(false);
    }
  }, [searchPlanList, planListFilter]);

  const addAllPlans = () => {
    setAddedPlans([...planListFilter, ...addedPlans]);
    var list = planListFilter.filter((team) => {
      return (
        team.planName.toLowerCase().includes(searchAddedPlans.toLowerCase()) ||
        team.rkPlanNumber.includes(searchAddedPlans)
      );
    });
    setAddedPlansFilter([...list, ...addedPlansFilter]);
    var temp = plans.filter(
      (plan) => !planListFilter.map((item) => item.planId).includes(plan.planId)
    );
    setPlans(temp);
    setPlanListFilter([]);
    setFilteredPlans([]);
  };

  const addPlansToPlanGroup = (data) => {
    setAddedPlans([data, ...addedPlans]);
    if (
      data.planName.toLowerCase().includes(searchAddedPlans.toLowerCase()) ||
      data.rkPlanNumber.includes(searchAddedPlans)
    ) {
      setAddedPlansFilter([data, ...addedPlansFilter]);
    }
    setPlans(plans.filter((e) => e.planId !== data.planId));
    setPlanListFilter(planListFilter.filter((e) => e.planId !== data.planId));
    setFilteredPlans(planListFilter.filter((e) => e.planId !== data.planId));
  };
  return (
    <div className="leftcol-2-fees">
      <div className="marg-left-13">
        <div className="fee-header-font marg-top-15 marg-bot-15">
          Plan Information
        </div>
        <div>
          <div className="searchbar-width">
            <Form>
              <div className="flex-search">
                <InputGroup>
                  <InputGroup.Prepend>
                    <div className="searchIconPostion-fee">
                      <i class="fal fa-search" aria-hidden="true"></i>
                    </div>
                  </InputGroup.Prepend>

                  <SearchBar
                    size="sm"
                    type="search"
                    placeholder="Search plan name & ID"
                    className="PadLeftSearch"
                    onChange={(e) => setSearchPlanList(e.target.value)}
                  />
                </InputGroup>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="smallOptions">
        <div className="small-text w-310">{planListFilter.length} Plans</div>
        <div className="small-text w-45 marg-left-30">
          <p
            className="link blue-small addallLink mb-0"
            style={{ cursor: "pointer" }}
            onClick={() => addAllPlans()}
          >
            {isExclude ? "Exclude " : "Add "} all
          </p>
        </div>
      </div>
      {planListFilter.map((data, index) => {
        return (
          <div className="fee-plan-card mt-20 ml-10">
            <div className="card-top">
              <div className="d-flex justify-content-space-between">
                <div className="fee-header-card-font">
                  Plan ID: {data.rkPlanNumber}
                </div>

                <p
                  className="link-font"
                  style={{ cursor: "pointer", color: "#2f80ed" }}
                  onClick={() => addPlansToPlanGroup(data)}
                >
                  Click to {isExclude ? "exclude" : "add"} {`>>`}
                </p>
              </div>
            </div>
            <div className="fee-body-card-font ml-10 mt-10">
              {data.planName}
            </div>
            {data.planStatus === 0 && (
              <div className="underconstuction-backgd">
                <div className="underconstuction-font">UnderConstruction</div>
              </div>
            )}
            {data.planStatus === 1 && (
              <div className="readyforapproval-backgd">
                <div className="readyforapproval-font">ReadyForApproval</div>
              </div>
            )}
            {data.planStatus === 2 && (
              <div className="approved-backgd">
                <div className="approved-font">Approved</div>
              </div>
            )}
            {data.planStatus === 3 && (
              <div className="active-backgd d-flex">
                <div className="active-font">Active</div>
              </div>
            )}
            {data.planStatus === 4 && (
              <div className="inactive-backgd d-flex">
                <div className="inactive-font">InActive</div>
              </div>
            )}
            {data.planStatus === 5 && (
              <div className="terminated-backgd d-flex">
                <div className="terminated-font">Terminated</div>
              </div>
            )}
          </div>
        );
      })}
      {noMatchesFound && (
        <div className="fee-bodyfilter-font mleft-8r mt-6r">
          No matches found
        </div>
      )}
    </div>
  );
};

export default FeeApplicableToPlanInfoCard;
